import { render, staticRenderFns } from "./RunsInvalidation.vue?vue&type=template&id=4dd1f042"
import script from "./RunsInvalidation.vue?vue&type=script&lang=js"
export * from "./RunsInvalidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports